import { AnaColumn } from "./forms-template.service";
import { aspect } from "./templates/aspect";
import { gridSimple, createGridConfig, gridMultiple } from "./templates/gridSettings/gridSettings"

export const autorizzazione: AnaColumn[] = [

  {
    configuration:
    {
      titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
      titleForm: 'descrizioneSoggetto - $descrizioneSede',
      breadcrumbCaption: 'Autorizzazioni',

      campoTitle: ['descrizioneSede', 'descrizioneSoggetto'],
      service: 'autorizzazione',
      api: 'autorizzazione',
      filterList: '/$idSede',
      filterEditor: '?id=$',
      helpDoc: 'Autorizzazioni1.html',
      startTemplate: 'grid',
      queryFilter: [
        {
          key: 'idAutorizzazione',
          value: 'id'
        },

        {
          key: 'idSede',
          value: 'idSede'
        }
      ],
      idTabRif: [
        {
          key: 'idSede',
          value: 'idSede'
        },
        {
          key: 'idSede',
          value: 'idProduttore'
        },

      ],
      formType: 'simple',
      masterKey: 'id',
      nCol: 2,
      toolbarSettings: {
        service: 'autorizzazione',

      }





    }

  },



  {
    itemType: "buttonMenu", colCount: "1", class: "col-12", caption: "",

    data: [
      {
        type: 'menuToolbar', orderGriglia: 1, colVisible: true, hideOnEdit: true, disableOnUpdate: true, buttons: [

          { name: 'Autor. Aree', icon: 'glyphicon icon-cer-area', dataSource: 'autorizzazionearea', costantValue: 'idSede', hint: 'Autorizzazioni Area', event: '3', location: 'top', displayMode: 'in-line' },
          { name: 'Autor. CER', icon: 'glyphicon icon-giacenze-cer', hint: 'Autorizzazioni CER', value: '', costantValue: 'idSepde', dataSource: 'autorizzazionecer', event: '3', location: 'top', displayMode: 'in-line' },
          { name: 'Utility', icon: 'mdi mdi-settings-outline', displayMode: 'in-line', hint: 'Utility', event: "2", value: 'utility', location: 'bottom', visible: true },

        ]
      }
    ]
  },

  {
    itemType: "group", colCount: "2", caption: 'Estremi Autorizzazione Impianto', class: "mt-3",
    data: [
      { type: 'campo', dataField: "id", colVisible: false, dataType: "", caption: "ID", hideOnEdit: true },
      {
        showInColumnChooser: false, allowHiding: false, type: 'campo', dataField: "idSede", colVisible: false, dataType: "", caption: "idSede", hideOnEdit: true,

      },



      {
        type: 'campo', dataField: "descrizione", caption: 'Descrizione', dataType: "",
        showInColumnChooser: true, allowHiding: false,
        orderGriglia: 1,
        colVisible: true,

        maxLength: 45,
        nCol: 8,
        colSpan: '2',

      },

      {
        showInColumnChooser: true,
        allowHiding: false,
        type: 'campo', dataField: "numero", caption: "Numero",
        // colSpan:'2',
        maxLength: '16',
        maxSize: 16,
        orderGriglia: 2,
        colWidth: '91px',
        width: 50,
        nCol: 4,
        validation: [
          { type: "required", message: "Numero autorizzazione è obbligatorio" },

        ],

      },

      {
        showInColumnChooser: false,
        type: 'campo',
        nCol: 4,
        // colSpan:'2',
        dataField: 'isArt110',
        colVisible: false,
        dataType: 'boolean',
        showEditorAlways: false,
        trueText: 'Si',
        falseText: 'No',
        editorType: 'dxCheckBox',
        caption: 'Articolo 110',
        colWidth: '50px',
      },

      // {
      //   type: 'campo',
      //   dataField: 'idTipoAutorizzazioneRentri',
      //   dataType: 'number',
      //   visible: false
      // },
      {
        type: 'campo',
        dataField: 'tipoAutorizzazioneRentriCodice',
        dataType: 'string',
        caption: 'Codice Aut. Rentri',
        class: 'disabileVisibile',
        disabled: true,
        nCol: 4,
      },
      {
        type: 'campo',
        dataField: 'idTipoAutorizzazioneRentri',
        dataType: 'string',
        caption: 'Aut. Rentri',
        nCol: 4,
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'TipoAutorizzazioneRentri',
          autocomplete: false,
          valueExpr: 'id',     //'object', prima
          displayExpr: 'descrizione', //'id' prima
          related: ['code|tipoAutorizzazioneRentriCodice'],
          caption: "Lista Autorizzazioni Rentri",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Aut. Rentri',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista Aut. Rentri',
            name: 'TipoAutorizzazioneRentri',
            location: 'after',
          },
          settingGrid: createGridConfig(
            {
              ...gridSimple,
              width: 1400,
              isOdata: false,
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',

                  allowEditing: true,
                  colVisible: false
                },
                {
                  dataField: 'code',
                  dataType: '',
                  caption: 'Codice',
                  colWidth: 24,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',

                  allowEditing: true,
                },
              ]
            }),



        }
      },

      {
        showInColumnChooser: true,
        allowHiding: false,
        type: 'campoData',
        dataField: "dataRilascio",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        caption: "Data Rilascio",
        orderGriglia: 3,
        colWidth: '150px',
        nCol: 3,
      },
      {
        showInColumnChooser: true,
        allowHiding: false,
        type: 'campoData',
        dataField: "dataScadenza",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        caption: "Data Scadenza",
        orderGriglia: 4,
        colWidth: '150px',
        nCol: 3,
      },

      {
        showInColumnChooser: true, allowHiding: false,
        type: 'campo',
        dataField: "ente",
        colVisible: true,
        dataType: "",
        caption: "Rilasciata da",

        hideOnEdit: false,
        orderGriglia: 5,
        nCol: 8,
        maxLength: '45',

        colSpan: '2'
      },


      {
        maxLength: "255",
        colVisible: false,
        maxSize: 256,
        showInColumnChooser: false,
        type: 'campo',
        dataField: "appunti",
        caption: "Appunti",
        dataType: "",
        editorType: "dxTextArea",
        colSpan: '2',
        nCol: 8,

        height: 150 + 'px',
        colWidth: '200px'
      },


    ]
  },
  {
    itemType: "group", colCount: "2", colGroup: 5, colSpan: 5, caption: '', class: 'no-line-caption mt-1', data: [
      {
        type: 'empty',
        colSpan: '2',
        class: 'py-0',
        dataField: "",
        colVisible: false,
        dataType: "",
        caption: "Quantitativi max gestibili (ton)",
        hideOnEdit: false,
      },
      {
        type: 'campo',
        dataField: "maxGiacenza",
        colVisible: false,
        dataType: "",
        caption: "Max giacenza istanziata",
        hideOnEdit: false,
        editorType: 'dxNumberBox',
        helpText: '(Ton)',
        class: 'hideHelpText',
        // width: 25,
        maxLength: '9',
        format: '#0.###',
        showInColumnChooser: false,
        // colWidth:'110px',
        nCol: 3,
        labelWidth: 124,
      },
      {
        type: 'campo',
        dataField: "maxCaricoAnno",
        colVisible: false,
        dataType: "",
        caption: "Max carico anno",
        hideOnEdit: false,
        helpText: '(Ton)',
        class: 'hideHelpText',
        editorType: 'dxNumberBox',
        // colWidth:'110px',
        labelWidth: 124,
        maxLength: '9',
        // width: 25,
        nCol: 3,
        format: '#0.###',
        showInColumnChooser: false,
      },
      { type: 'empty', colSpan: '3' },

      {
        type: 'campoSpecial',
        dataField: "listaModStoccaggio",
        dataType: "",
        nCol: 6,
        // width: 62.6,
        caption: "Modalità di stoccaggio",
        labelWidth: 124,
        colVisible: false,
        labelVisible: true,
        disableOnUpdate: true,
        showInColumnChooser: false,
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,
          valueExpr: 'id',     //'object', prima
          displayExpr: '', //'id' prima
          //service:'generic', prima
          caption: "Lista Operazioni Smaltimento",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Modalità di Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: false,
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            }),



        }
      },

      { type: 'empty', colSpan: '2' },



      { type: 'empty', colSpan: '2', class: 'mt-3', dataField: "", colVisible: false, dataType: "", caption: "Quantitativi max trattabili (ton)", hideOnEdit: false, },

      {
        type: 'campo', dataField: "maxTrattamentoGiorno", colVisible: false, dataType: "", caption: "Max giornaliero", hideOnEdit: false,
        editorType: 'dxNumberBox',
        showInColumnChooser: false,
        labelWidth: 124,
        nCol: 3,
        maxLength: '9',
        format: '#0.###',
        helpText: '(Ton)',
        class: 'hideHelpText',
        colWidth: '110px',
      },
      {
        type: 'campo', dataField: "maxtrattamentoAnno", colVisible: false, dataType: "", caption: "Max anno", hideOnEdit: false,
        editorType: 'dxNumberBox', showInColumnChooser: false,
        labelWidth: 124,
        nCol: 3,
        maxLength: '9',
        format: '#0.###',
        helpText: '(Ton)',
        colWidth: '110px',
        class: 'hideHelpText',
      },


      {
        type: 'campoSpecial', dataField: "listaModTrattamento", dataType: "", caption: "Modalità trattamento",
        colVisible: false,
        labelVisible: true,
        colSpan: '2',
        disableOnUpdate: true,
        labelWidth: 124,
        showInColumnChooser: false,
        nCol: 6,

        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          //service:'generic', prima
          autocomplete: false,
          valueExpr: 'id', //'object' prima
          displayExpr: '', //'id' prima
          caption: "Lista Oper. trattamento",
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Trattamneto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia trattameno',
            name: 'Trattamento',
            location: 'after'

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: false,
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })

        }

      },




    ]

  }
]